import React from 'react'
import styled from 'styled-components'

import { FieldPrefix } from '../../../../../../../../../1stlog-ui/src/components/Field'
import DebugTime from './DebugTime'
import FixedAppointment from './FixedAppointment'
import FixedWindow from './FixedWindow'
import OwnArea from './OwnArea'
import { RecommendedTimePicker } from './RecommendedTimePicker'
import TimeWindow from './TimeWindow'
import V2Time from './V2Time'
import TimeValidation from './V2Time/TimeValidation'

const Wrapper = styled.div`
  margin-left: 1.5rem;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
`

const TimeSettings = (props) => {
  const {
    isPickup,
    id,
    name,
    isRequestOnly,
    requiresConfirmation,
    debug,
    type,
    timeOptions,
  } = props

  let innerComponent = null

  if (id === 'fixedWindow') {
    innerComponent = <FixedWindow />
  }
  if (id === 'fixedAppointment') {
    innerComponent = <FixedAppointment />
  }
  if (id === 'timeWindow') {
    innerComponent = <TimeWindow />
  }
  if (id === 'ownArea') {
    innerComponent = <OwnArea isPickup={isPickup} />
  }
  if (debug) {
    innerComponent = <DebugTime {...props} />
  }
  if (type === 'v2') {
    innerComponent = <V2Time {...props} />
  }

  // const requiresConfirmation = useField("settings.requiresConfirmation")

  // const {
  //   "type": "pickup",
  //   "additionalService": null,
  //   "from": "2021-05-02T06:00:00.000Z",
  //   "until": "2021-05-02T00:00:00.000Z",
  //   "avis": "2021-05-02T05:00:00.000Z",
  //   "requiresConfirmation": true,
  //   "mode": "lefttimespan",
  //   "minAvisFromNow": 60,
  //   "minimalTimespan": 60
  // }=props
  // console.log("TimeSettings", props)
  return (
    <FieldPrefix prefix="settings">
      <Wrapper>
        {/* {/localhost/.test(window.location) && (
          <div>
            <code>{id}</code>
          </div>
        )} */}
        <div>{innerComponent}</div>
        <TimeValidation key={id} {...props} />
        {global.isGO && !isPickup && <RecommendedTimePicker />}
        {/* {(isRequestOnly || requiresConfirmation) && <Confirmation />} */}
        {/* <div>requiresConfirmation: {requiresConfirmation ? "yes" : "no"} </div> */}
        {/* {/localhost/.test(window.location) && (
          <pre>{JSON.stringify(props.timing, 0, 2)}</pre>
        )} */}
      </Wrapper>
    </FieldPrefix>
  )
}

export default TimeSettings
